import { db, storage } from './firebase';
import { firestoreKeys } from '../utils/constants';

export default function useRestaurantService() {
  const createRestaurant = (userId, data) => db.collection(firestoreKeys.RESTAURANTS).doc(userId).set(data);

  // New: truly create a new restaurant with an auto-generated id (1:many model)
  const addRestaurant = async (data) => {
    const ref = await db.collection(firestoreKeys.RESTAURANTS).add(data);
    return ref.id;
  };

  const updateRestaurant = (restaurantId, data) =>
    db.collection(firestoreKeys.RESTAURANTS).doc(restaurantId).update(data);

  const updateRestraurantTimes = (restaurantId, times) => {
    console.log(times, restaurantId);
    db.collection(firestoreKeys.RESTAURANTS).doc(restaurantId).update({ openTimes: times });
  };

  const addRestaurantImage = (docId, image) => {
    const ref = storage.ref(`${firestoreKeys.RESTAURANTS}/${docId}/${image.name}`);
    return ref.put(image).then(() => ref.getDownloadURL());
  };

  const deleteRestaurantImage = (url) => {
    try {
      const ref = storage.refFromURL(url);
      return ref.delete();
    } catch (e) {
      // If the URL is not a Firebase Storage URL, swallow error to avoid blocking metadata update
      return Promise.resolve();
    }
  };

  const getRestaurant = (userId) => db.collection(firestoreKeys.RESTAURANTS).doc(userId).get();

  const deleteRestaurant = async (restaurantId) =>
    db.collection(firestoreKeys.RESTAURANTS).doc(restaurantId).delete();

  return {
    createRestaurant,
    addRestaurant,
    updateRestaurant,
    addRestaurantImage,
    deleteRestaurantImage,
    getRestaurant,
    deleteRestaurant,
    updateRestraurantTimes,
  };
}
